import { Solver } from "@decisionrules/decisionrules-js/dist";

const apiKey: string | undefined =
  process.env.REACT_APP_DECISION_RULES_SOLVER_API_KEY;
const solver = new Solver(apiKey ?? "");

// const data = {
//   departureDate: 12,
//   arrivalDate: 12,
//   continents: "america",
//   travelType: "work-manual",
//   sportActivities: "risk-sports",
//   numberOfPeople: 1,
//   peopleAge: 18,
// };

export const DRPostGet = async (ruleId: string, payload: any) => {
  try {
    let response = await solver.solveRule(ruleId, payload, 1);
    return response;
  } catch (Err: any) {
    throw Error("DR POST was not successful: ", Err);
  }
};
